import { Button, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Spinner } from "reactstrap";
import { Card } from "../../CommonElements/Hajj/Card";
import { useResetUserPasswordMutation } from "../../services/user";
import { Link, useParams } from "react-router";
import {
  CircleLockCheck01Icon,
  LockPasswordIcon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useState } from "react";
import ConfirmModal from "../../CommonElements/ConfirmModal";

export const ResetUserPassword = () => {
  const { id: user_id } = useParams();
  const {
    mutate: resetUserPasswordMutation,
    isPending,
    isSuccess,
  } = useResetUserPasswordMutation();

  const { t } = useTranslation();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleResetUserPassword = () => {
    resetUserPasswordMutation({ user_id: user_id });
    setIsConfirmModalOpen(false);
  };

  const handleShowConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <>
      <PageHeader
        title={t("RESET_USER_PASSWORD")}
        backTo={`/app/user_management/users`}
      />

      <Container fluid={true} className="mt-5">
        <Card className="pattern-card mx-auto" style={{ maxWidth: "36.32rem" }}>
          {isSuccess ? (
            <Stack gap={3} className="text-center py-4">
              <div className="text-success mb-3">
                <HugeiconsIcon size={60} icon={CircleLockCheck01Icon} />
              </div>
              <h4 className="text-success">
                {t("RESET_PASSWORD_SUCCESSFULLY")}
              </h4>
              <p className="text-muted">
                {t("RESET_PASSWORD_SUCCESSFULLY_DESCRIPTION")}
              </p>
              <Link
                className="btn btn-primary"
                to={`/app/user_management/users/${user_id}/profile`}
              >
                {t("GO_TO_THE_USER_PROFILE")}
              </Link>
            </Stack>
          ) : (
            <Stack gap={3} className="py-4">
              <div className="text-center">
                <div className="mb-3">
                  <HugeiconsIcon size={48} icon={LockPasswordIcon} />
                </div>
                <h5 className="mb-3 H2">{t("RESET_PASSWORD_WARNING_TITLE")}</h5>
                <p className="text-secondary H5 fw-bold mb-4">
                  {t("RESET_PASSWORD_WARNING_DESCRIPTION")}
                </p>
              </div>
              <Button
                disabled={isPending}
                onClick={handleShowConfirmModal}
                className="btn-danger w-100"
              >
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("RESET_PASSWORD_IN_PROGRESS")}
                  </>
                ) : (
                  <>{t("RESET_PASSWORD")}</>
                )}
              </Button>
            </Stack>
          )}
        </Card>
      </Container>

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onToggle={handleCloseConfirmModal}
        onConfirm={handleResetUserPassword}
        title={t("RESET_PASSWORD")}
        message={`${t("ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_PASSWORD")} ${t(
          "THIS_WILL_MAKE_THE_CURRENT_USER_PASSWORD_NO_LONGER_WORK"
        )}`}
        confirmText={t("RESET_PASSWORD")}
        cancelText={t("CANCEL")}
        confirmVariant="danger"
        isLoading={isPending}
        confirmIcon={LockPasswordIcon}
        loadingText={t("RESET_PASSWORD_IN_PROGRESS")}
      />
    </>
  );
};
